export const GET_PERMISSIONS = `
  query GetPermissionsByRole($roleId: ID) {
    permissions(roleId: $roleId) {
      id
      isActive
      role {
        id
        name
      }
      entitlement {
        id
        name
      }
    }
  }
`;

export const ACTIVATE_PERMISSION = `
  mutation ActivatePermisson($id: ID!) {
    activatePermission(id: $id){
      permission {
        id
        isActive
        role {
          id
          name
        }
        entitlement {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const DEACTIVATE_PERMISSION = `
  mutation DeactivatePermisson($id:ID!) {
    deactivatePermission(id: $id){
      permission {
        id
        isActive
        role {
          id
          name
        }
        entitlement {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }`;
